/*!
 * KoliBri - The accessible HTML-Standard
 */
import { r as registerInstance, h, H as Host, g as getElement } from './index-C_ZKddLG.js';
import { _ as __decorate } from './tslib.es6-QNbPBOk5.js';
import { g as watchString, s as setState } from './common-D-vggmh2.js';
import { v as validateHasCloser } from './has-closer-DoXfZcmn.js';
import { v as validateHref } from './href-C9xfRiDr.js';
import { v as validateLabel } from './label-w3T7Y2ih.js';
import { t as translate } from './i18n-CvFPh0g5.js';
import { w as watchHeadingLevel } from './validation-Cnndf99L.js';
import { b as KolButtonWcTag } from './component-names-DwvrfFak.js';
import './Alert-BjiZcCeA.js';
import { c as createUniqueId } from './dev.utils-Cib2ENyx.js';
import { K as KolHeadingFc } from './Heading-CNfXfPK2.js';
import './base-web-component-D909Fl-Y.js';
import './variant-quote-ClYWonZq.js';
import './component-DepnuZGT.js';
import { b as directFocus, e as directClick, c as createCtaRef } from './element-interaction-C5-6aPzz.js';
import { d as dispatchDomEvent, K as KolEvent } from './events-BhfZTW2e.js';
import './i18n-C73LqPIs.js';
import './level-Cj2m5HKt.js';
import './normalizers-BNeak4hj.js';
import './_Uint8Array-kJHDjtoP.js';
import './isArray-CcrBs4JM.js';
import './clsx-COFh-Vc8.js';
import './bem-registry-3ondDImf.js';
import './component-BjVFpeYY.js';
import './element-focus-BQXzaLL9.js';

const validateLinkTarget = (component, value) => {
    watchString(component, '_target', value);
};

const KolCardWc = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        this.translateClose = translate('kol-close');
        this.ctaRef = createCtaRef();
        this.close = () => {
            var _a;
            if (((_a = this._on) === null || _a === void 0 ? void 0 : _a.onClose) !== undefined) {
                this._on.onClose(new Event('Close'));
            }
            if (this.host) {
                dispatchDomEvent(this.host, KolEvent.close);
            }
        };
        this.on = {
            onClick: this.close,
        };
        this.onFocus = (event) => {
            var _a, _b, _c;
            (_c = (_b = (_a = this.state) === null || _a === void 0 ? void 0 : _a._on) === null || _b === void 0 ? void 0 : _b.onFocus) === null || _c === void 0 ? void 0 : _c.call(_b, event);
            if (this.host) {
                dispatchDomEvent(this.host, KolEvent.focus);
            }
        };
        this.onBlur = (event) => {
            var _a, _b, _c;
            (_c = (_b = (_a = this.state) === null || _a === void 0 ? void 0 : _a._on) === null || _b === void 0 ? void 0 : _b.onBlur) === null || _c === void 0 ? void 0 : _c.call(_b, event);
            if (this.host) {
                dispatchDomEvent(this.host, KolEvent.blur);
            }
        };
        this._hasCloser = false;
        this._headingId = createUniqueId('card-heading');
        this._level = 0;
        this.state = {
            _label: '',
        };
        this.validateOnValue = (value) => typeof value === 'object' && value !== null && typeof value.onClose === 'function';
    }
    async focus(options) { }
    async click() { }
    render() {
        return (h(Host, { key: '815ad13c0c4f0a262766c4533c149bc6f288eb8f' }, h("article", { key: '6704819da54380ec371616185ec5c14936a75121', "aria-labelledby": this._headingId, class: "kol-card" }, this._href && (h("a", { key: 'a20eebc6da8cfdefe34b1ff3cedcb23836ac48cc', href: this._href, target: this._target, class: "kol-card__link", onFocus: this.onFocus, onBlur: this.onBlur, ref: this.ctaRef }, h(KolHeadingFc, { key: 'ec1ee02c0b9d970b01ad5ddfaedb0650ba8d0454', class: "kol-card__header", id: this._headingId, level: this.state._level }, this.state._label))), !this._href && (h(KolHeadingFc, { key: '29e4c23691ee8c18f7ab4aedf93286d8d46e0947', class: "kol-card__header", id: this._headingId, level: this.state._level }, this.state._label)), h("div", { key: '40e9e7b7ad85b8b2755f81aa8c083fb9e41f32b6', class: "kol-card__content" }, h("slot", { key: 'ad0a1f0109650e24200486aaafe376e0a16f3026' })), this.state._hasCloser && (h(KolButtonWcTag, { key: '502c5698b0c937401c4c09dc91d16ce90be0ed57', class: "kol-card__close-button kol-close-button", "data-testid": "card-close-button", _hideLabel: true, _icons: {
                left: {
                    icon: 'kolicon-cross',
                },
            }, _label: this.translateClose, _on: this.on, _tooltipAlign: "left" })))));
    }
    validateHasCloser(value) {
        validateHasCloser(this, value);
    }
    validateHref(value) {
        validateHref(this, value);
    }
    validateLabel(value) {
        validateLabel(this, value, {
            required: true,
        });
    }
    validateLevel(value) {
        watchHeadingLevel(this, value);
    }
    validateOn(value) {
        if (this.validateOnValue(value)) {
            setState(this, '_on', {
                onClose: value.onClose,
            });
        }
    }
    validateTarget(value) {
        validateLinkTarget(this, value);
    }
    componentWillLoad() {
        this.validateHasCloser(this._hasCloser);
        this.validateHref(this._href);
        this.validateLabel(this._label);
        this.validateLevel(this._level);
        this.validateOn(this._on);
        this.validateTarget(this._target);
    }
    get host() { return getElement(this); }
    static get watchers() { return {
        "_hasCloser": ["validateHasCloser"],
        "_href": ["validateHref"],
        "_label": ["validateLabel"],
        "_level": ["validateLevel"],
        "_on": ["validateOn"],
        "_target": ["validateTarget"]
    }; }
};
__decorate([
    directFocus('ctaRef')
], KolCardWc.prototype, "focus", null);
__decorate([
    directClick('ctaRef')
], KolCardWc.prototype, "click", null);

export { KolCardWc as kol_card_wc };
//# sourceMappingURL=kol-card-wc.entry.js.map
